/**
 * Main layout component with sidebar
 */

import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Layout.css';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>TrazaVolt</h2>
          <p className="sidebar-subtitle">by iForeCast</p>
        </div>

        <nav className="sidebar-nav">
          <Link
            to="/dashboard"
            className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
          >
            Dashboard
          </Link>
          <Link
            to="/installations"
            className={`nav-link ${isActive('/installations') ? 'active' : ''}`}
          >
            Instalaciones
          </Link>
          <Link
            to="/checklists"
            className={`nav-link ${isActive('/checklists') ? 'active' : ''}`}
          >
            Checklists
          </Link>
          <Link
            to="/reports"
            className={`nav-link ${isActive('/reports') ? 'active' : ''}`}
          >
            Informes
          </Link>
          <Link
            to="/assistant"
            className={`nav-link ${isActive('/assistant') ? 'active' : ''}`}
          >
            Asistente
          </Link>
          {(user?.role === 'Admin' || user?.role === 'Supervisor') && (
            <Link
              to="/audit"
              className={`nav-link ${isActive('/audit') ? 'active' : ''}`}
            >
              Auditoría
            </Link>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-name">{user?.name || user?.email}</div>
            <div className="user-role">{user?.role}</div>
          </div>
          <button onClick={logout} className="btn-logout">
            Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="main-content">
        {children}
      </main>
    </div>
  );
}

